// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || "";

const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState("loading"); // 'loading' | 'ok' | 'unauth'

  useEffect(() => {
    let mounted = true;

    async function check() {
      try {
        // Cache-bust with a timestamp so the browser never serves a stale 200
        // NOTE: No custom headers — they trigger a CORS preflight that the server blocks
        const res = await fetch(
          `${API_BASE}/api/auth/check?_=${Date.now()}`,
          {
            method: "GET",
            credentials: "include", // send httpOnly session cookie
          }
        );

        if (!mounted) return;

        if (res.ok) {
          sessionStorage.setItem("isAuthenticated", "true");
          setStatus("ok");
        } else {
          // 401 / 403 — session expired or never created
          sessionStorage.removeItem("isAuthenticated");
          localStorage.removeItem("videoKyc_logged_in");
          localStorage.removeItem("videoKyc_token");
          localStorage.removeItem("user_logged_in");
          setStatus("unauth");
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        if (!mounted) return;
        sessionStorage.removeItem("isAuthenticated");
        setStatus("unauth");
      }
    }

    check();
    return () => {
      mounted = false;
    };
  }, []);

  if (status === "loading") {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
        }}
      >
        <span
          style={{
            color: "rgba(64,190,180,0.6)",
            fontSize: "13px",
            letterSpacing: "2px",
            fontFamily: "monospace",
          }}
        >
          Verifying session…
        </span>
      </div>
    );
  }

  return status === "ok" ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
